export default function (data) {
    const bookingData = data || {}
    const capturedQueryParams = this.$wire.get('capturedQueryParams') || {}
    const isEditing = this.$wire.get('isEditing')
    if (isEditing) return

    const getFieldValue = (fieldPath, item) => {
      if (bookingData[fieldPath]) {
        return bookingData[fieldPath]
      }
      if (!item.settings) return null

      if (item.settings.prefilled_from_query && item.settings.query_param) {
        const value =
          capturedQueryParams[item.settings.query_param.replace(/\./g, '_')]
        if (value) return value
      }

      return item.settings.default_value ?? null
    }

    const formatDatetime = (dateString) => {
      const utcDate = new Date(dateString + 'Z')
      const pad = (num) => num.toString().padStart(2, '0')
      const year = utcDate.getFullYear()
      const month = pad(utcDate.getMonth() + 1)
      const day = pad(utcDate.getDate())
      const hours = pad(utcDate.getHours())
      const minutes = pad(utcDate.getMinutes())
      const seconds = pad(utcDate.getSeconds())

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }

    const applyValueToField = (fieldMapping, item, value) => {
      if (!value) return

      switch (item.type) {
        case 'checkbox': {
          const checkInput = document.getElementsByName(fieldMapping).item(0)
          if (checkInput && value) {
            checkInput.checked = value
          }
          break
        }

        case 'radio':
          { const radioCollection = document.getElementsByName(fieldMapping)
          if (radioCollection && value) {
            radioCollection.forEach((radio) => {
              radio.checked = radio.defaultValue === value
            })
          }
          break }

        case 'datetime':
          { const dateInput = document.getElementsByName(fieldMapping).item(0)
          if (dateInput && value) {
            dateInput.value = formatDatetime(value)
          }
          break }
        // case 'multiselect':
        //     const multiselect = this.multiSelects[field.form_mapping];
        //     if(multiselect){
        //         multiselect.setValue(bookingData[field.form_mapping]);
        //     }
        // break;
        default:
          {
            const input = document.getElementsByName(fieldMapping).item(0)
            if (input && value) {
              input.value = value
            }
          break
          }
      }
    }

    const prefillEntities = (
      bookingData,
      entityItems,
      entities,
      entitiesName,
    ) => {
      entityItems.forEach((item) => {
        const field = item.field
        // AIRLST-5622: an orphaned item (its field was deleted) has no mapping to prefill.
        if (!field) return
        entities.forEach((companion, index) => {
          const byKey = `${entitiesName}.${companion.key}.${field.form_mapping}`
          const byIndex = `${entitiesName}.${index}.${field.form_mapping}`

          if (item.type === 'bookable-group') {
            // TODO: Implement bookable group handling for companions
            return
          }

          applyValueToField(byKey, item, getFieldValue(byIndex, item))
        })
      })
    }

    this.items = this.$wire.get('items')
    const bookables = this.$wire.get('bookables')
    this.items.forEach((item) => {
      if (item.type === 'bookable-group') {
        const group = item.bookable_group
        if (group?.type === 'cars') {
          group.bookable_objects.forEach((bookableObject) => {
            const bookableData = Object.values(bookables).find(
              (data) => data.core_id === bookableObject.core_id,
            )
            const reservationData = bookableData['reservation']
            for (const subKey of [
              'reservation_id',
              'start_date',
              'start_time',
              'end_date',
              'end_time',
            ]) {
              const fieldKey = `${bookableObject.form_mapping}.${subKey}`
              const input = document.getElementsByName(fieldKey).item(0)
              const dataKey = subKey !== 'reservation_id' ? subKey : 'id'
              if (input && reservationData[dataKey]) {
                input.value = reservationData[dataKey]
              }
            }
          })
        }
        if (group?.type === 'tickets') {
          let foundBookableId = null
          let foundReservationId = null
          group.bookable_objects.forEach((bookableObject) => {
            for (const [key, value] of Object.entries(bookingData)) {
              const match = key.match(/^reservations\.(\d+)\.bookable_id$/)
              if (match && value === bookableObject.core_id) {
                const index = match[1]
                foundReservationId = bookingData[`reservations.${index}.id`]
                foundBookableId = bookableObject.id
                break
              }
            }
          })
          const fieldKey = `${group.form_mapping}.bookable_object_id`
          const radioCollection = document.getElementsByName(fieldKey)
          if (radioCollection && foundBookableId) {
            radioCollection.forEach((radio) => {
              radio.checked = Number(radio.defaultValue) === foundBookableId
            })
          }
          const reservationFieldKey = `${group.form_mapping}.reservation_id`
          const input = document.getElementsByName(reservationFieldKey).item(0)
          if (input && foundReservationId) {
            input.value = foundReservationId // fixme: for some reason onMultiFormFieldUpdate call erase it, temp fix to overwrite before submit applied!
          }
        }
        return
      }

      // AIRLST-5622: never let one orphaned item abort the whole prefill run (and with it init()).
      if (!item.field) return

      applyValueToField(
        item.field.form_mapping,
        item,
        getFieldValue(item.field.form_mapping, item),
      )
    })

    this.companionItems = this.$wire.get('companionItems')
    const companions = this.$wire.get('companions')
    prefillEntities(bookingData, this.companionItems, companions, 'companions')
    this.recommendationItems = this.$wire.get('recommendationItems')
    const recommendations = this.$wire.get('recommendations')
    prefillEntities(
      bookingData,
      this.recommendationItems,
      recommendations,
      'recommendations',
    )
  }
